import { initSaveStages, initSendEmail } from './save-stages';
import { initStageHandlers } from './handlers';


export function stages() {
	initSaveStages();
	initSendEmail();
	initStageHandlers();
}
